<template>
  <div>
    <div class="title mb-2">
      請告訴我這件商品是什麽？
    </div>

    <div v-if="parcel && parcel.extraInfo && parcel.extraInfo.tpTaobaoTradeItems && parcel.extraInfo.tpTaobaoTradeItems.length">
      品名無法辨識，請更換一個商品頁登記。
    </div>

    <!-- 图片上传区域 -->
    <div>
      <v-card
        outlined
        class="image-upload-area mt-4"
        style="width: 350px;margin: 0 auto;"
        @click="selectImage"
      >
        <v-card-text
          v-if="!uploadedImage"
          class="text-center pa-8"
        >
          <v-icon
            size="64"
            color="grey lighten-1"
          >
            image
          </v-icon>
          <div class="mt-2 subtitle-1 grey--text">
            提交商品圖片以圖識物
          </div>
          <v-btn
            color="info"
            class="mt-4"
            large
          >
            以圖識物
          </v-btn>
        </v-card-text>

        <v-card-text
          v-else
          class="pa-4"
        >
          <div class="uploaded-image-container">
            <img
              :src="uploadedImage"
              alt="上传的商品图片"
              class="uploaded-image"
            >
            <v-icon
              class="remove-image-btn"
              @click.stop="removeImage"
            >
              close
            </v-icon>
          </div>
        </v-card-text>

        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none;"
          @change="onFileSelected"
        >
      </v-card>
    </div>
    <!-- 加载状态 -->
    <div
      v-if="searchLoading"
      class="text-center py-4"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="mt-2 grey--text">
        正在識別圖片中的商品...
      </div>
    </div>

    <!-- 切换到文字搜索 -->
    <div class="text-center mt-4">
      <v-btn
        flat
        color="primary"
        @click="$emit('change-input-type', 'goodsSearch')"
      >
        <u>輸入關鍵字選擇相似商品</u>
      </v-btn>
    </div>

    <v-divider class="my-4" />

    <!-- 搜索结果 -->
    <div v-if="searchGoodsList && searchGoodsList.length">
      <div class="subtitle-1 mb-3">
        選擇一個最相似的商品：
      </div>
      <v-layout
        wrap
        class="mt-2"
      >
        <v-flex
          v-for="item in searchGoodsList"
          :key="item.id || item.itemid"
          xs4
          class="searchGoodsItem mb-2"
          @click="toggleItem(item)"
        >
          <div class="itemContent pb-2">
            <img
              :src="item.itemPic ? item.itemPic.replace('_80x80.jpg','_200x200.jpg') : ''"
              alt="商品圖片"
              style="aspect-ratio: 3/4;object-fit: cover;"
            >
            <div
              class="line-clamp-2 caption mt-1"
              style="height: 3em;"
              :title="item.title || item.itemName"
            >
              {{ item.title || item.itemName }}
            </div>
            <div class="choseBtn">
              <v-icon
                v-if="choseItemid === (item.id || item.itemid)"
                class="blue--text"
              >
                check_circle
              </v-icon>
              <v-icon v-else>
                radio_button_unchecked
              </v-icon>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <!-- 错误信息 -->
    <v-alert
      v-if="errorMsg"
      :value="true"
      type="error"
      class="mt-4"
    >
      {{ errorMsg }}
    </v-alert>
  </div>
</template>

<script>
import Compressor from 'compressorjs'

export default {
  name: 'Step2ImageSearch',
  props: {
    parcel: {
      type: Object,
      default: null
    },
    itemQty: {
      type: String,
      default: '1'
    },
    memo: {
      type: String,
      default: ''
    },
    errorMsg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      uploadedImage: '',
      imageBase64: '',
      searchLoading: false,
      searchGoodsList: [],
      choseItem: null
    }
  },
  computed: {
    choseItemid () {
      return this.choseItem ? (this.choseItem.id || this.choseItem.itemid) : ''
    }
  },
  methods: {
    selectImage () {
      this.$refs.fileInput.click()
    },

    onFileSelected (event) {
      const file = event.target.files[0]
      if (!file) return

      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.$snackbar('請選擇圖片文件', { color: 'error' })
        return
      }

      // 使用 Compressor 压缩图片
      // eslint-disable-next-line no-new
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 300,
        maxHeight: 300,
        minWidth: 100,
        minHeight: 100,
        success: (compressedFile) => {
          console.log('compressed image', compressedFile.name, compressedFile.size, compressedFile.type)
          const reader = new FileReader()
          reader.onload = (e) => {
            this.uploadedImage = e.target.result
            // 去除数据URL的前缀，只保留base64字符串
            this.imageBase64 = e.target.result.split(',')[1]
            this.searchByImage()
          }
          reader.readAsDataURL(compressedFile)
        },
        error: (err) => {
          console.error('图片压缩失败:', err)
          this.$snackbar('圖片壓縮失敗，請重試', { color: 'error' })
        }
      })
    },

    removeImage () {
      this.uploadedImage = ''
      this.imageBase64 = ''
      this.searchGoodsList = []
      this.choseItem = null
      this.$emit('item-changed', null)
      this.$refs.fileInput.value = ''
    },

    async searchByImage () {
      if (!this.imageBase64) {
        this.$snackbar('請先選擇圖片', { color: 'error' })
        return
      }

      try {
        this.searchLoading = true
        this.$emit('error', '') // 清除之前的错误信息

        const res = await this.$store.dispatch('magicbuy/dgorder/searchByImage', {
          imageBase64: this.imageBase64
        })

        if (res.data.error) {
          this.$emit('error', res.data.msg || '圖片識別失敗，請重試')
        } else {
          // 转换数据格式以与关键字搜索保持一致
          const convertedList = (res.data.list || []).map(item => {
            let itemPic = item.pic_urls && item.pic_urls[0] ? item.pic_urls[0] : ''
            if (!itemPic && item.sku_list?.length) {
              itemPic = item.sku_list[0].pic_url
            }
            return {
              ...item,
              id: item.item_id,
              itemid: item.item_id, // 将 item_id 转换为 itemid
              imageUrls: item.pic_urls || [], // 将 pic_urls 转换为 imageUrls
              itemCid: item.category_id, // 将 category_id 转换为 itemCid
              itemPic // 将第一张图片设为 itemPic
            }
          }).filter(item => item.itemPic)

          this.searchGoodsList = convertedList.filter(item => {
            if (this.parcel && this.parcel.extraInfo && this.parcel.extraInfo.tpTaobaoTradeItems) {
              return this.parcel.extraInfo.tpTaobaoTradeItems.find(i => i.itemid === item.itemid) === undefined
            }
            return true
          }).slice(0, 12)

          if (this.searchGoodsList.length === 0) {
            this.$emit('error', '未找到相似商品，請嘗試其他圖片或使用關鍵字搜索')
          }
        }
      } catch (error) {
        console.error('图片搜索错误:', error)
        this.$emit('error', '圖片識別失敗，請檢查網絡連接後重試')
      } finally {
        this.searchLoading = false
      }
    },

    toggleItem (item) {
      const itemid = item.itemid || item.id
      if (this.choseItemid === itemid) {
        this.choseItem = null
        this.$emit('item-changed', null)
      } else {
        this.choseItem = item
        this.$emit('item-changed', this.choseItem)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.image-upload-area {
  cursor: pointer;
  transition: border-color 0.3s;
  min-height: 200px;

  &:hover {
    border-color: #2196F3 !important;
  }
}

.uploaded-image-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.uploaded-image {
  max-width: 100%;
  max-height: 160px;
  border-radius: 4px;
  object-fit: contain;
}

.remove-image-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.searchGoodsItem {
  padding: 10px;
  cursor: pointer;
  img {
    width: 100%;
  }
  .itemContent {
    border: 1px dashed rgba(0,0,0,0.2);
    border-radius: 5px;
    padding: 3px;
    position: relative;
    .choseBtn {
      position: absolute;
      left: 0px;
      top: 0px;
      background: #fff;
    }
  }
}
</style>
